module.exports = __webpack_public_path__ + "cjml_app_pcui/img/wu.dba353fb.png";